'use client'

// libraries
import clsx from 'clsx'

// components
import Hero, { HeroProps } from '/react4xp/components/Hero'
import Section from '/react4xp/components/Section'
import RoundedBox from '/react4xp/components/RoundedBox'
import ContentSlider, { ContentSliderProps } from '/react4xp/components/ContentSlider'

// utils
import useTableWrapper from '/react4xp/utils/useTableWrapper'
import { formatDate } from '/react4xp/utils/functions'

// css
import './index.scss'

// types
interface ArticleProps {
    className?: string
    hero?: HeroProps
    author?: {
        label?: string
        name?: string
        url?: string
    }
    reviewedBy?: {
        text?: string
    }
    publicationDate?: {
        label?: string
        date?: string
    }
    updatedDate?: {
        label?: string
        date?: string
    }
    content?: React.ReactNode
    contentSlider?: ContentSliderProps
    bottomRegion?: React.ReactNode
    text?: string
}

export default function Article({
    className,
    hero,
    author,
    reviewedBy,
    publicationDate,
    updatedDate,
    content,
    contentSlider,
    bottomRegion,
    text
}: ArticleProps) {

    useTableWrapper()

    return (
        <div className={clsx('page-article', className)}>

            {hero && (
                <Hero {...hero} />
            )}

            <Section className='page-article__content'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-10 offset-lg-1 col-xl-6 offset-xl-3'>

                            {(author?.name || reviewedBy?.text) && (
                                <div className='page-article__meta'>

                                    {author?.name && (
                                        <p className='page-article__author'>
                                            {author.label && (
                                                <span className='page-article__author-label'>{author.label}: </span>
                                            )}
                                            {author.url ? (
                                                <a className='page-article__author-link' href={author.url}>{author.name}</a>
                                            ) : (
                                                <span className='page-article__author-name'>{author.name}</span>
                                            )}
                                        </p>
                                    )}

                                    {reviewedBy?.text && (
                                        <p className='page-article__reviewed-by'>{reviewedBy.text}</p>
                                    )}

                                </div>
                            )}

                            {content && (
                                <div className='rich-text-article'>
                                    {content}
                                </div>
                            )}

                            {text && (
                                <div className='rich-text-article' dangerouslySetInnerHTML={{ __html: text }} suppressHydrationWarning />
                            )}

                            {(publicationDate || updatedDate) && (
                                <RoundedBox
                                    bgColor='beige'
                                    className='page-article__publication-date'
                                >

                                    {publicationDate?.date && (
                                        <span className='page-article__publication-date__span'>
                                            <span>{publicationDate.label}</span>
                                            <span>{formatDate(publicationDate.date || '')}</span>
                                        </span>
                                    )}

                                    {updatedDate?.date && (
                                        <span className='page-article__publication-date__span'>
                                            <span>{updatedDate.label}</span>
                                            <span>{formatDate(updatedDate.date || '')}</span>
                                        </span>
                                    )}

                                </RoundedBox>
                            )}

                        </div>
                    </div>
                </div>
            </Section>

            {contentSlider && (
                <ContentSlider {...contentSlider} />
            )}

            {bottomRegion && (
                <>
                    {bottomRegion}
                </>
            )}

        </div>
    )
}